/* eslint-disable react/prop-types */
'use client';
import { Box, Button, Divider, Stack, Typography, useTheme } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useState } from 'react';
import AudioPlayer from '../../components/AudioPlayer';
import CartImage from "../../components/CartImage";
import useSettings from '../../hooks/useSettings';

function Question({ item, index }) {
  const theme = useTheme();
  const { themeMode } = useSettings();
  const isLight = themeMode === 'light';

  const statusStyle = (answer) => {
    if (check) {
      if (item.a === answer) {
        return isLight ? theme.palette.success.light : theme.palette.success.dark;
      }
      if (item.a !== answer && indexA === answer) {
        return isLight ? theme.palette.error.light : theme.palette.error.dark;
      }
    }
  };

  const [value, setValue] = useState('');
  const [indexA, setIndex] = useState(null);
  const [check, setCheck] = useState(false);

  const handleChange = (event) => {
    setValue(event.target.value);
    setIndex(parseInt(event.target.value));
  };

  const handleShow = () => {
    setCheck(true);
  };

  const text = item.q + ' ' + item.c?.map((answer, index) => `${index + 1}. ${answer}`).join(' ');

  return (
    <Stack bgcolor={isLight ? "#fcfaf6" : theme.palette.background.neutral} spacing={2} pt={2} my={2} >
      <Stack spacing={1} px={3}>
        <AudioPlayer text={text} index={index + 1} />
        <Typography variant="body1">
          <strong>Câu {index + 1}:</strong> {item.q}
        </Typography>
        {item.i !== '' && <CartImage item={item} />}
      </Stack>
      <Divider />
      <FormControl>
        <RadioGroup
          value={value}
          onChange={handleChange}
        >
          {[1, 2, 3, 4].map((answer) => (item.c[answer - 1] && (
            <FormControlLabel
              value={answer}
              control={<Radio />}
              key={answer}
              sx={{ backgroundColor: statusStyle(answer), py: 1, m: 0, px: 2 }}
              label={
                <Typography variant="body1">
                  {answer}. {item.c[answer - 1]}
                </Typography>
              }
            />
          )))}
        </RadioGroup>
      </FormControl>

      <Box px={3} bgcolor={isLight ? theme.palette.warning.light : theme.palette.background.neutral}>
        {check && <Typography my={1}>
          <strong>Giải thích:</strong> <span dangerouslySetInnerHTML={{ __html: item.e }} />
        </Typography>}
        <Button variant='text' color='error' sx={{ p: 0 }} size='large' onClick={handleShow}>Gợi ý đáp án</Button>
      </Box>
    </Stack>
  );
}

export default Question;
